import { MoneyType } from "../Money";
import {
  InvalidPaymentInstructionReason,
  PositionTabStatus,
  UnableToPayReason,
} from "./StepComponents/SelectPositionsStep/SelectPositionsTable/constants";

// PaymentInstructionsStatus enum for tracking payment instruction validity
export enum PaymentInstructionsStatus {
  Valid = "VALID",
  Invalid = "INVALID",
  Missing = "MISSING",
  PendingChanges = "PENDING_CHANGES",
}

export type PositionRowData = {
  // Common fields
  positionId: number;
  positionName: string;
  netPayment: MoneyType;
  paymentMethod: string | null;
  paymentPrefId: number | null;
  paymentInstructionsStatus: PaymentInstructionsStatus;

  // Instance reference - generic
  instanceId: number;
  instanceObjectType: string;

  // Display fields
  investorName: string;
  entityName: string;
  positionUrl?: string;
  bankAccountInstitutionName?: string;
  bankAccountLastFour?: string;

  // Validation
  isSelectable: boolean;
  unselectableReason?: UnableToPayReason;
  invalidPaymentInstructionReason?: InvalidPaymentInstructionReason;

  // Payment instruction tracking
  paymentInstructionsRecentlyUpdated: boolean;

  // Tab classification
  positionTabStatus: PositionTabStatus;
};

export type PaymentBatchWorkflowStepProps = {
  onBack: () => void;
  onContinue: (error?: Error) => void;
};

export type PaymentCapabilities = {
  wirePayments: boolean;
  achPayments: boolean;
};

export const DEFAULT_PAYMENT_CAPABILITIES: PaymentCapabilities = {
  wirePayments: true,
  achPayments: false,
};
